import React from 'react';
import Pie from '@splunk/dashboard-visualizations/Pie';

export default () => (
    <Pie
        options={{ fieldColors: { December: '#008000', May: '#FF0000' } }}
        encoding={{
            value: 'primary.count',
            label: 'primary.component',
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'component' }, { name: 'count' }],
                    columns: [
                        [
                            'January',
                            'February',
                            'March',
                            'April',
                            'May',
                            'June',
                            'July',
                            'August',
                            'September',
                            'October',
                            'November',
                            'December',
                        ],
                        ['1', '1', '1', '2', '10', '10', '5', '5', '5', '5', '5', '50'],
                    ],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
